import { AWSImageConverter, truncateAddress } from '../utils/helpers/helper'

type UserColumnProps = {
  image: string | null | undefined
  username: string | undefined
  address: string
}

function UserColumn({ image, username, address }: UserColumnProps) {
  return (
    <div className='flex items-center gap-[14px]'>
      <img
        src={image ? AWSImageConverter(image) : '/avatar-placeholder.png'}
        className='w-[35px] h-[35px] rounded flex-shrink-0'
        alt='user'
      />
      <div className='flex flex-col'>
        <span className='text-base font-medium leading-normal font-poppins'>{username || 'N/A'}</span>
        <span className='text-sm text-primary-blue-100'>{truncateAddress(address)}</span>
      </div>
    </div>
  )
}

export default UserColumn
